import { createContext, useContext, useState } from "react";

const AltCtx = createContext({ alternates: [], setAlternates: () => {} });

export const AltProvider = ({ children }) => {
  const [alternates, setAlternates] = useState([]);
  return <AltCtx.Provider value={{ alternates, setAlternates }}>{children}</AltCtx.Provider>;
};

export const useAlternates = () => useContext(AltCtx);
